{
  "$schema": "./skinning_variables.schema.json",
  "### This JSON overrides some style properties for the darkmode (gridscale style)": "",
  "### Only works as an extension with skinning_variables_default": "",
  "### REMEMBER: That all variables MUST be present in `skinConfigObj` in skinconfig.model.ts file - in snake_case! Even the private ones !!!!": "",
  "######################################################": "",
  "darkModeColor": "#82b5c6",
  "_darkBackgroundColor": "#0e1e29",
  "_darkerBackgroundColor": "#05121b",
  "_brighterBackgroundColor": "#213441",
  "_evenBrighterBackgroundColor": {
    "sass-function": "lighten",
    "sass-function-args": [
      "$_brighterBackgroundColor",
      10
    ]
  },
  "_darkBorderColor": "#21313d",
  "_textOnDarkcolor": "#a5b4c0",
  "_labelColor": "#5a6f7e",
  "_statusGrey": "#8198a9",
  "primaryColor": "#bfd0de",
  "buttonColorDisabled": "#061621",
  "buttonColorDisableOverlay": "#2c414f",
  "headerBackgroundColor": "$_darkBackgroundColor",
  "headerFormColor": "#FFFFFF",
  "h1Color": "#FFFFFF",
  "h2Color": "#FFFFFF",
  "h3Color": "#FFFFFF",
  "h4Color": "#FFFFFF",
  "h5Color": "$primaryColor",
  "h6Color": "$primaryColor",
  "iconsColor": "$darkModeColor",
  "igBoxShadow": "0 0 15px 0 #000",
  "igBoxShadowColor": "transparent",
  "igBoxShadowBlur": "0px",
  "igColorAccordionHeaderBackground": "$_darkBackgroundColor",
  "igColorAccordionHeaderForeground": "$primaryColor",
  "igColorAccordionHeaderActiveBackground": "$_darkBackgroundColor",
  "igColorAccordionHeaderActiveForeground": "$primaryColor",
  "igColorAccordionHeaderHoverBackground": "$_darkBackgroundColor",
  "igColorAlertInfoBackground": "$_brighterBackgroundColor",
  "igColorAlertInfoForeground": "$_textOnDarkcolor",
  "igColorAlertSuccessBackground": "#25461a",
  "igColorAlertSuccessForeground": "#ddfad5",
  "igColorAlertErrorBackground": "#6e0c0e",
  "igColorAlertErrorForeground": "#ffe4e1",
  "igColorAlertWarningBackground": "#41433e",
  "igColorAlertWarningForeground": "#fffac6",
  "igColorBlack": "#FFFFFF",
  "igColorSuccessGreen": "#5ec03e",
  "igColorSuccessGreenLight": "#25461a",
  "igColorSuccessGreenHover": "#ddfad5",
  "igColorWarningRed": "#c53538",
  "igColorWarningRedLight": "#f7a6a7",
  "igColorNoteYellow": "#41433e",
  "igColorHintOrange": "#ee9f4c",
  "igColorCardBackground": "$_darkBackgroundColor",
  "igColorCardBackgroundHover": "$_brighterBackgroundColor",
  "igColorCardBorder": "$_darkBorderColor",
  "igColorCardLabel": "$_textOnDarkcolor",
  "igColorDashboardConnectionLines": "$primaryColor",
  "igColorDashboardObjectNames": "#FFFFFF",
  "igColorDetailsHeaderHeadline": "#FFFFFF",
  "igColorEmptyStateAddButtonBackground": "$darkModeColor",
  "igColorEmptyStateAddButtonForeground": "$primaryTextColor",
  "igColorFormClickareaBackground": "$_brighterBackgroundColor",
  "igColorFormClickareaBackgroundHover": "$_evenBrighterBackgroundColor",
  "igColorFormClickareaBackgroundHighlight": "$darkModeColor",
  "igColorFormClickareaForegroundBold": "$_textOnDarkcolor",
  "igColorFormClickareaForegroundBoldHighlight": "#061621",
  "igColorFormClickareaForegroundLight": "$primaryColor",
  "igColorFormClickareaForegroundLightHighlight": "#061621",
  "igColorFormDropdownSelected": "$primaryColor",
  "igColorFormDropdownPlaceholder": {
    "sass-function": "rgba",
    "sass-function-args": [
      "$igColorFormDropdownSelected",
      "0.5"
    ]
  },
  "igColorFormInputBackground": "transparent",
  "igColorFormInputForeground": "#FFFFFF",
  "igColorFormInputSwitchBackgroundOff": "#2e4351",
  "igColorFormInputSwitchHandleOff": "#061621",
  "igColorFormInputSwitchBackgroundOn": "$iconsColor",
  "igColorFormInputSwitchHandleOn": "#061621",
  "igColorHeaderIconBackground": "$_brighterBackgroundColor",
  "igColorHeaderIconForeground": "#FFFFFF",
  "igColorLabel": "$_labelColor",
  "igColorLabel2": "$primaryColor",
  "igColorLabelLight": "$_statusGrey",
  "igColorMainMenuBackground": "$_darkBackgroundColor",
  "igColorMainMenuForeground": "$_textOnDarkcolor",
  "igColorMainMenuActiveBackground": "$_brighterBackgroundColor",
  "igColorMainMenuActiveForeground": "$primaryColor",
  "igColorMainMenuHoverBackground": "$_evenBrighterBackgroundColor",
  "igColorSideMenuActiveBackground": "$igColorMainMenuActiveBackground",
  "igColorMenuBackground": "#0e1e29",
  "igColorMenuBackgroundHover": "$_brighterBackgroundColor",
  "igColorMenuBackgroundProjectSwitchHover": "#354652",
  "igColorMenuBackgroundHighlight": "$darkModeColor",
  "igColorMenuForeground": "$primaryColor",
  "igColorMenuForegroundHighlight": "#061621",
  "igColorMenuForegroundLight": "$_statusGrey",
  "igColorOverlayAlertCloseButtonBackground": "#2d3e4a",
  "igColorOverlayAlertCloseButtonForeground": "#adc4d6",
  "igColorOverlayAlertDimmer": "rgba(5, 18, 27, 0.7)",
  "igColorOverlayAlertMessage": "#adc4d6",
  "igColorPriceTableForeground": "$_statusGrey",
  "igColorPriceTableForegroundBold": "#FFFFFF",
  "igColorPriceTableHeaderBackground": "$_brighterBackgroundColor",
  "igColorPriceTableHeaderForeground": "#FFFFFF",
  "igColorPriceListHeaderBackground": "#0e1e29",
  "igColorPriceListHeaderForeground": "$_statusGrey",
  "igColorPriceListHeaderForegroundBold": "$primaryColor",
  "igColorStatusGrey": "$_statusGrey",
  "igColorTooltipBackground": "#193c4c",
  "igColorTooltipForeground": "#FFFFFF",
  "igColorTooltipShadow": "none",
  "igColorViewportBackground": "$_darkerBackgroundColor",
  "igColorWhite": "$_darkBackgroundColor",
  "igTextColor": "$_statusGrey",
  "igColorTextDarker": "#FFFFFF",
  "inputCheckboxBorder": "$_labelColor",
  "inputFormBorder": "#304757",
  "loginIconHeadlineColor": "#adc4d6",
  "priceboxColorBackground": "#193c4c",
  "priceboxBorderColor": "#44687f",
  "primaryTextColor": "#081c2a",
  "roundedIconBackgroundInactive": "$_brighterBackgroundColor",
  "roundedIconColorActive": "$_darkerBackgroundColor",
  "roundedIconColorInactive": "#FFFFFF",
  "secondaryColor": "$darkModeColor",
  "secondaryTextColor": "#05121b",
  "tableCellActionIconColor": "$tableCellForegroundColor",
  "tableCellBackgroundColor": "$_darkBackgroundColor",
  "tableCellModalBackgroundColor": "$tableCellBackgroundColor",
  "tableCellForegroundColor": "#627888",
  "tableCellLinkForegroundColor": "$primaryColor",
  "tableHeaderBackgroundColor": "$_brighterBackgroundColor",
  "tableCellBackgroundColorHover": "#1b2d39",
  "tableCellModalBackgroundColorHover": "$tableCellBackgroundColorHover",
  "tableHeaderFontColor": "$primaryColor",
  "tableHeaderBorderColor": "$_darkBorderColor",
  "tableHeaderCheckboxBorderColor": "$inputCheckboxBorder",
  "tableSelectedActionsLinkColor": "$primaryColor",
  "tableSelectedActionsHoverBackgroundcolor": "$_brighterBackgroundColor",
  "tableSelectedActionsLabel": "#627888",
  "###this colors are only overwritten for gs darkmode###": "",
  "igColorHeaderBorders": "#304757",
  "igColorPriceTableBorder": "#304757",
  "igColorListValue": "$secondaryColor",
  "backgroundData": "#05121b",
  "igColorHelpcenterBulletBackground": "$_darkBackgroundColor",
  "igColorHelpcenterBulletForeground": "$primaryColor",
  "igColorHelpcenterHeaderGradientFrom": "#344d59",
  "igColorHelpcenterHeaderGradientTo": "#0b1d2a",
  "igColorProgressbarBackground": "$_brighterBackgroundColor",
  "igColorChecklistGreenBackground": "$igColorSuccessGreen",
  "igColorChecklistGreenForeground": "$secondaryTextColor",
  "igColorEmptystateIcon": "$primaryColor",
  "igColorEmptystateText": "$_statusGrey",
  "linkColor": "$primaryColor",
  "linkColorHover": "$primaryDarkColor",
  "igColorMoreIconForeground": "#627888",
  "igColorMoreIconHoverBackground": "#354652",
  "igColorMoreIconHoverForeground": "$primaryColor",
  "igColorFormInputPlaceholderForeground": "#627888",
  "igColorDropdownGroupHeaderBackground": "transparent",
  "igColorDropdownGroupHeaderForeground": "$_labelColor",
  "tableCellBorderDefault": "#061621",
  "tableCellBorderGroup": "#193c4c",
  "igColorDesignerPreviewOutline": "$_brighterBackgroundColor",
  "igMenuOverlayBoxShadow": "$igBoxShadow",
  "igColorBreadcrumbForeground": "$_labelColor",
  "ctaButtonBackgroundColor": "#5ec03e",
  "checklistButtonBackground": "$darkModeColor",
  "checklistButtonHoverBorderColor": "#476a76",
  "igColorBillingInvoiceInfoForeground": "$_statusGrey"
}
